export default {
    url: '',
}